import(/* webpackMode: "eager" */ "/home/runner/work/pteultra-home/pteultra-home/app/global-error.tsx");
